<div class="flex items-center pl-2">
    <p
        class="detail-header-text"
        [class]="columnWidthClasses.controlPoint">
        {{ 'controlPoint' | transloco: { COUNT: 1 } }}
    </p>

    <p
        class="detail-header-text"
        [class]="columnWidthClasses.result">
        {{ 'result' | transloco: { COUNT: 1 } }}
    </p>

    <p
        class="detail-header-text"
        [class]="columnWidthClasses.status">
        {{ 'status' | transloco: { COUNT: 1 } }}
    </p>

    <div [class]="columnWidthClasses.actions"></div>
</div>
